import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Iconmenu from '@cybs-ui/components/lib/icon-menu';

const MoreActions = ({ actionBarId, actions, dataTest, i18n, isActive }) => {
  // Map actions from ButtonProps to Iconmenu format
  const items =
    actions && actions.map
      ? actions.map(action => ({
          value:
            action.value ||
            action.i18n.value ||
            action.i18n.label ||
            action.i18n.tooltipLabel,
          label: action.i18n.label || action.i18n.tooltipLabel
        }))
      : [];

  // Hooks
  const [selected, setSelection] = useState(items[0]);
  const [isOpen, setopenState] = useState(false);

  const handleSelection = (e, selectedItems) => {
    const selectedItem = selectedItems[0];

    // When clicking on items in the "more options" menu,
    // we want to call the onClick event like we would if those actions were instead rendered as buttons.
    // First, find the action data that corresponds to this selectedItem.
    const matchingActionObject = actions.find(
      action =>
        selectedItem.value === action.value ||
        selectedItem.value === action.i18n.value ||
        selectedItem.value === action.i18n.label ||
        selectedItem.value === action.i18n.tooltipLabel
    );
    // Then invoke that action object's onClick callback.
    matchingActionObject.onClick();

    setSelection(selectedItem);
    setopenState(!isOpen);
  };

  return items.length ? (
    <Iconmenu
      buttonProps={{
        'aria-describedby': (i18n.title && actionBarId) || undefined,
        'aria-controls': i18n.title && actionBarId,
        colorScheme: 'secondary',
        iconClass: 'options',
        iconType: 'light',
        label: 'Action',
        onButtonClick: (event, open) => setopenState(open),
        onButtonKeyDown: (event, open) => setopenState(open),
        tooltipLabel: i18n.moreActionsLabel,
        variant: 'icon'
      }}
      disabled={!isActive}
      dataTest={`${dataTest}-moreActionsButton`}
      isOpen={isOpen}
      items={items}
      onClickOutside={() => setopenState(false)}
      onSelect={handleSelection}
      position={{ horizontal: 'right', vertical: 'bottom' }}
      selectedItem={selected}
    />
  ) : null;
};

MoreActions.displayName = 'MoreActionsButton';

MoreActions.propTypes = {
  /**
  * Level of the heading displayed before the component
  */
  actionBarId: PropTypes.string.isRequired,
  /**
   * Actions to generate menu list in more actions.
   */
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      label: PropTypes.string,
      title: PropTypes.string,
      value: PropTypes.string,
      onClick: PropTypes.func.required
    })
  ).isRequired,
  /**
   * dataTest string for testing.
   */
  dataTest: PropTypes.string.isRequired,
  /**
   * Strings for the component.
   */
  i18n: PropTypes.shape({
    title: PropTypes.string.isRequired,
    moreActionsLabel: PropTypes.string
  }),
  /**
   * Whether or not gridtable has items selected.
   * Or if you wan to activate/deactivate dropdown.
   */
  isActive: PropTypes.bool
};

MoreActions.defaultProps = {
  i18n: { moreActionsLabel: 'More Actions' },
  isActive: true
};

export default MoreActions;
